import { useMutation } from "@apollo/client";
import {
    constantsData,
    identifiersData,
    namesData,
    statusTypesData,
} from "data";
import { deleteTrackFormatMutation, getTracksFormatsListQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useDeleteTrackFormat = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { deleteTrackFormatPending: deleteTrackFormatPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const [deleteArtistAction, { loading }] = useMutation(
        deleteTrackFormatMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getTracksFormatsListQuery,
                },
            ],
        },
    );

    const deleteTrackFormat = async (id) => {
        try {
            await deleteArtistAction({
                onCompleted: () => {
                    dispatch(openAlert(
                        t(
                            "messages.deleteMsgs.success",
                            { entity: t("tracksFormats.entity") },
                        ),
                        statusTypesData.success,
                    ));
                },

                variables: {
                    id,
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${deleteTrackFormatPendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(
                    () => t(
                        "messages.deleteMsgs.pending",
                        { entity: t("tracksFormats.entity") },
                    ),
                    { toastId: `${deleteTrackFormatPendingToastName}_${toastId}` },
                );
            }
        },
        [loading], //eslint-disable-line
    );

    return { deleteTrackFormat };
};

export default useDeleteTrackFormat;
